var FilterPanel = /** @class */ (function() {
  function FilterPanel () {
    var _this = this;
    this.el = {
      container: document.getElementById('filter-panel'),
      filters: document.querySelectorAll('#filter-panel input, #filter-panel select'),
      submitButton: document.querySelectorAll('#filter-panel button'),
      clearButtons: document.querySelectorAll('#filter-panel button.clear'),
      dateRangeFilter: document.getElementById('p_date_start-p_date_end'),
      dateRangeFilterClient: document.getElementById('p_payment_date'),
      dateStart: document.getElementById('p_date_start'),
      dateEnd: document.getElementById('p_date_end'),
      titleID: document.getElementById('titleId'),
      sourcesID: document.getElementById('sourceId'),
      formatsID: document.getElementById('formatId'),
      itemsPerPage: document.getElementById('itemsPerPage'),
    };
    // convert input fields to URL params
    this.converters = {
      directQueryString: function(el) {
        var param = new UrlParam();
        param.key = el.name;
        param.value = el.value;
        param.stringRepresentation = param.key + '=' + param.value;
        return param;
      },
      dateRange: function(el) {
        var param = new UrlParam();
        param.key = 'fr';
        param.value = el.name;
        // date ranges are split by spaces and dashes
        param.subValue = el.value.replace(' - ', ',');
        param.stringRepresentation = param.key + '[]=' + param.value + '~' + param.subValue;
        return param;
      },
      dateRangeMultiColumn: function(el) {
        var params = [];
        // get the two columns / url param keys we're setting the range on
        var columns = el.name.split('-');
        var value = el.value.replace(' - ', ',');
        columns.forEach(function(column) {
          var param = new UrlParam();
          param.key = 'fr';
          param.value = column;
          // date ranges are split by spaces and dashes
          param.subValue = value;
          param.stringRepresentation = param.key + '[]=' + param.value + '~' + param.subValue;
          params.push(param);
        });
        return params;
      },
      directMultiSelect: function(el) {
        var params = [];
        var values = jQuery(el).val();
        values.forEach(function(value) {
          var param = new UrlParam();
          param.key = el.name;
          param.value = value;
          param.stringRepresentation = param.key + '=' + param.value;
          params.push(param);
        });
        return params;
      },
    };
    // hide start/end if user is a client
    if (window.sflow.isClient) {
      if (this.el.dateStart) {
        this.el.dateStart.classList.add('hide');
      }
      if (this.el.dateEnd) {
        this.el.dateEnd.classList.add('hide');
      }
    }
    // find url params associated with input boxes on the page
    this.getUrlParamFromQueryString().forEach(function(urlParam) {
      var inputEl = document.getElementById(urlParam.value);
      if (inputEl !== null) {
        // @ts-ignore
        inputEl.value = urlParam.subValue.replace(',', ' - ');
        inputEl.dispatchEvent(new Event('click'));
        document.dispatchEvent(new Event('click'));
      }
    });
    // hack to fill in q param on page
    var qEl = document.getElementById('q');
    if (qEl !== null) {
      // is q in QS
      var qValueInQueryString = window.location.search.match(/q=(.*?)&/);
      if (qValueInQueryString === null) {
        qValueInQueryString = window.location.search.match(/q=(.*?)$/);
      }
      if (qValueInQueryString !== null) {
        // @ts-ignore
        qEl.value = qValueInQueryString[1];
        qEl.dispatchEvent(new Event('blur'));
      }
    }
    // hack to ensure range shows the right value
    if (this.el.dateRangeFilter !== null) {
      if (this.el.dateStart.value == this.el.dateEnd.value) {
        this.el.dateRangeFilter.value = this.el.dateStart.value;
        this.el.dateRangeFilter.dispatchEvent(new Event('blur'));
      }
      // Make sure we clear out the start/stop individual boxes, so this combined field's value takes precedent
      this.el.dateRangeFilter.addEventListener('blur', function(e) {
        _this.el.dateStart.value = '';
        _this.el.dateEnd.value = '';
      });
    }
    if (this.el.dateRangeFilterClient !== null) {
      this.getUrlParamFromQueryString().forEach(function(param) {
        if (param.value == 'p_payment_date') {
          _this.el.dateRangeFilterClient.value = decodeURI(param.subValue).replace(/,/, ' - ');
          _this.el.dateRangeFilterClient.dispatchEvent(new Event('blur'));
        }
      });
    }
  }

  FilterPanel.prototype.clearAssociatedRange = function() {
  };
  FilterPanel.prototype.getFiltersAsUrlParameters = function() {
    var _this = this;
    var filtersAsParameters = [];
    // iterate over filters
    this.el.filters.forEach(function(el) {
      if (el.value !== '') {
        switch (el.dataset.filterType) {
          case 'directQueryString':
            filtersAsParameters.push(_this.converters.directQueryString(el));
            break;
          case 'dateRange':
            filtersAsParameters.push(_this.converters.dateRange(el));
            break;
          case 'dateRangeMultiColumn':
            var params = _this.converters.dateRangeMultiColumn(el);
            params.forEach(function(param) {
              filtersAsParameters.push(param);
            });
            break;
          case 'directMultiSelect':
            var params = _this.converters.directMultiSelect(el);
            params.forEach(function(param) {
              filtersAsParameters.push(param);
            });
            break;
        }
      }
    });
    return filtersAsParameters;
  };
  FilterPanel.prototype.getUrlParamFromQueryString = function() {
    var paramObjects = [];
    var params = window.location.search.replace('?', '').split('&');
    params.forEach(function(param) {
      var paramParts = decodeURIComponent(param).match(/^(.*)(?:\[.?\])=(.*)~(.*)/);
      if (paramParts !== null) {
        var paramObject = new UrlParam();
        paramObject.stringRepresentation = decodeURIComponent(paramParts[0]);
        paramObject.key = decodeURIComponent(paramParts[1]);
        paramObject.value = decodeURIComponent(paramParts[2]);
        paramObject.subValue = decodeURIComponent(paramParts[3]);
        paramObjects.push(paramObject);
      }
    });
    return paramObjects;
  };
  FilterPanel.prototype.getMergedSearchParams = function(newParams) {
    var _this = this;
    var queryString = '';
    var existingParams = this.getUrlParamFromQueryString();
    // build new query string to use
    existingParams.forEach(function(existingParam) {
      var newParamExists = false;
      var isParamControlledInFilterPanel = false;
      // is there already a new param that overrides this? if not, add to query string
      newParams.forEach(function(newParam) {
        if (newParam.key == existingParam.key && newParam.value == existingParam.value) {
          newParamExists = true;
        }
      });
      // is this parameter controlled through the filter panel? Aka should filter panel empty value override a url param
      _this.el.filters.forEach(function(filterEl) {
        if (existingParam.value == filterEl.id) {
          isParamControlledInFilterPanel = true;
        }
      });
      if (!newParamExists && !isParamControlledInFilterPanel) {
        queryString += existingParam.stringRepresentation + '&';
      }
    });
    // now append new params
    newParams.forEach(function(newParam) {
      queryString += newParam.stringRepresentation + '&';
    });
    return queryString.replace(/&+$/, '');
  };
  FilterPanel.prototype.submit = function() {
    // get param representation of each filter
    var filtersAsParameters = this.getFiltersAsUrlParameters();
    // get current query string & merge in new params
    var mergedParams = this.getMergedSearchParams(filtersAsParameters);
    // submit
    window.history.pushState({}, '', location.pathname + '?' + mergedParams);
    window.location.reload();
  };
  FilterPanel.prototype.clear = function(elId) {
    var el = document.getElementById(elId);
    // try to get calentim object and set that to null as well
    // @ts-ignore
    var calentimEl = $(el).data('calentim');
    if (calentimEl !== undefined) {
      calentimEl.config.startDate = null;
      calentimEl.config.endDate = null;
    }
    // @ts-ignore
    el.value = '';
  };
  return FilterPanel;
}());
var UrlParam = /** @class */ (function() {
  function UrlParam () {
  }

  return UrlParam;
}());
// @ts-ignore
window.sflow = window.sflow || {};
window.sflow.filterPanel = new FilterPanel();
